import { render } from "./ScoreBoard.vue?vue&type=template&id=2d2dfcbc&ts=true"
import script from "./ScoreBoard.vue?vue&type=script&lang=ts"
export * from "./ScoreBoard.vue?vue&type=script&lang=ts"

import "./ScoreBoard.vue?vue&type=style&index=0&id=2d2dfcbc&lang=scss"

import exportComponent from "C:\\PROJEKTE\\GAMES\\shootEm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__